import type { CookieStore, CookieStoreSetOptions } from './CookieStore'

export type { CookieStore, CookieStoreSetOptions, SameSite } from './CookieStore'
export { applyCookieDomain } from './domain'
export { parseCookieHeader } from './parseCookieHeader'
export { ServerCookieStore } from './ServerCookieStore'
export { BrowserCookieStore } from './BrowserCookieStore'
export { createCookie } from './createCookie'
export { createServerCookies } from './createServerCookies'

/** In-memory {@link CookieStore} for tests — no consent, no I/O. */
export class MemoryCookieStore implements CookieStore {
  private readonly store = new Map<string, string>()

  get(name: string): Promise<string | undefined> {
    return Promise.resolve(this.store.get(name))
  }

  set(name: string, value: string, _options?: CookieStoreSetOptions): Promise<void> {
    this.store.set(name, value)
    return Promise.resolve()
  }

  remove(name: string, _options?: CookieStoreSetOptions): Promise<void> {
    this.store.delete(name)
    return Promise.resolve()
  }
}
